<template>
    <div class="pb-12">
        <div class="mx-4 lg:mx-auto pb-16 pt-20 lg:pt-32 max-w-4xl">
            <div
                class="flex flex-col justify-center px-4 lg:px-12 py-6 border border-[#3e90ff] rounded-[12px] lg:rounded-[30px]">
                <div class="text-center mb-12">
                    <p class="mt-4 lg:mt-8 text-lg lg:text-2xl font-semibold">申请演示</p>
                    <p class="mt-2 text-sm lg:text-lg">留下您的联系方式，我们尽快与您联系</p>
                </div>
                <a-form v-if="status === 'default'" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }"
                    @submit="handleSubmit">
                    <a-form-item class="mb-8" label="公司名称">
                        <a-input placeholder="请输入公司名称" :maxLength="50" allowClear size="large"
                            v-decorator="['businessName', { rules: [{ required: true, message: '请输入公司名称' }] }]" />
                    </a-form-item>
                    <a-form-item class="mb-8" label="用户名称">
                        <a-input placeholder="请输入您的姓名" :maxLength="50" allowClear size="large"
                            v-decorator="['userName', { rules: [{ required: true, message: '请输入您的姓名' }] }]" />
                    </a-form-item>
                    <a-form-item class="mb-8" label="联系电话">
                        <a-input placeholder="请输入你的联系电话" :maxLength="50" allowClear size="large" v-decorator="['phone', {
                            rules: [
                                { required: true, message: '请输入你的联系电话' },
                                { pattern: /^1[3456789]\d{9}$/, message: '请输入有效的中国大陆手机号码!' }
                            ]
                        }]" />
                    </a-form-item>
                    <a-form-item class="hidden lg:block mb-8" :wrapper-col="{ span: 12, offset: 5 }">
                        <a-button type="primary" html-type="submit" block size="large" :loading="loading">
                            点击提交
                        </a-button>
                    </a-form-item>
                    <a-form-item class="block lg:hidden mb-8">
                        <a-button type="primary" html-type="submit" block :loading="loading">
                            点击提交
                        </a-button>
                    </a-form-item>
                </a-form>
                <a-result v-if="status === 'success'" status="success" title="提交成功！">
                    <template #extra>
                        <a-button key="console" type="primary" @click="goHome">
                            回到首页
                        </a-button>
                    </template>
                </a-result>
            </div>
        </div>
    </div>
</template>

<script>
import { postApply } from './api';
import HomePageContact from './components/contact';
import HomePageToContact from './components/to-contact';

export default {
    name: 'homePageForm',
    components: {
        HomePageContact,
        HomePageToContact
    },
    data() {
        return {
            form: this.$form.createForm(this, { name: 'applyInfo' }),
            loading: false,
            status: 'default'
        };
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    console.log('Received values of form: ', values);
                    this.loading = true
                    postApply({
                        type: 'OTH',
                        name: values.businessName,
                        contactsInfo: [
                            {
                                name: values.userName,
                                telephone: values.phone
                            }
                        ],
                    }).then(() => {
                        this.status = 'success'
                        this.form.resetFields()
                    }).catch((e) => {
                        console.error(e)
                        this.status = 'default'
                        this.$message.error(e?.response?.data?.apierror?.message || '提交失败，请稍后重新填写')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            });
        },
        goHome() {
            window.location.href = '/'
        }
    }
}
</script>
